import { PlayerAvatarData } from '@/components/player-avatar/player-avatar-config';
import { EntryItemPick } from '@/feature/entries-pickem/components/EntriesList';

export const mapPlayerDataToAvatarData = (playerData: PlayerAvatarData | EntryItemPick): PlayerAvatarData => {
    if ('player' in playerData) {
        return {
            ...playerData.player,
            league: playerData.league,
            team: {
                color: playerData.teamColor,
                secondaryColor: playerData.secondaryTeamColor,
            },
        };
    }
    return playerData;
};
